import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=28342d7c&scoped=true&"
import script from "./BaseButton.vue?vue&type=script&lang=js&"
export * from "./BaseButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=28342d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../dashboard/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28342d7c",
  null
  
)

export default component.exports